import { config } from "config";
import { FaWhatsapp } from "react-icons/fa";

export const FloatingWhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/55${config.contact.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-success rounded-circle shadow-lg d-flex align-items-center justify-content-center whatsapp-float"
      aria-label="WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};
